import { render } from "./period-picker.vue?vue&type=template&id=792c7c1c&scoped=true&ts=true"
import script from "./period-picker.vue?vue&type=script&lang=ts"
export * from "./period-picker.vue?vue&type=script&lang=ts"

import "./period-picker.vue?vue&type=style&index=0&id=792c7c1c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-792c7c1c"]])

export default __exports__